import { safeSessionStorage } from 'legacyfrontend/helpers/ssr-helper';
import { SESSION_STORAGE_KEYS } from 'legacyfrontend/constants';

export const getCacheStatus = () => {
  try {
    const cache = safeSessionStorage.getItem(SESSION_STORAGE_KEYS.CACHE_STATUS);
    return cache === 'true';
  } catch (error) {
    console.warn('Error getting cache status:', error);
    return false;
  }
};

export const setCacheStatus = (status) => {
  try {
    safeSessionStorage.setItem(SESSION_STORAGE_KEYS.CACHE_STATUS, status.toString());
  } catch (error) {
    console.warn('Error setting cache status:', error);
  }
};
